// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.aboutus-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding-top: 60px;
}

/* Loading State */
.aboutus-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  font-size: 18px;
  gap: 15px;
  color: #333;
}

.loader {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #007bff;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Hero Banner Section */
.aboutus-hero {
  position: relative;
  height: 400px;
  overflow: hidden;
}

.aboutus-banner {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.aboutus-banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

/* Main Content Section */
.aboutus-main {
  max-width: 1200px;
  margin: -80px auto 0;
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

/* Header Section */
.aboutus-header {
  display: flex;
  align-items: center;
  gap: 40px;
  background: white;
  border-radius: 15px;
  padding: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;
  animation: slideUp 0.6s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.aboutus-logo-wrapper {
  flex-shrink: 0;
}

.aboutus-logo {
  width: 120px;
  height: 120px;
  border-radius: 15px;
  object-fit: cover;
  border: 4px solid #f0f0f0;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.aboutus-logo:hover {
  transform: scale(1.05);
}

.aboutus-title-section {
  flex-grow: 1;
}

.aboutus-name {
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
  line-height: 1.2;
}

.aboutus-en-name {
  font-size: 16px;
  color: #666;
  font-weight: 500;
}

/* Info Cards Grid */
.aboutus-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 50px;
}

.info-card {
  background: white;
  border-radius: 12px;
  padding: 30px 20px;
  text-align: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border-top: 4px solid #007bff;
}

.info-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
}

.card-icon {
  font-size: 40px;
  margin-bottom: 12px;
}

.info-card h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 10px;
}

.info-card p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* Description Section */
.aboutus-description {
  background: white;
  border-radius: 15px;
  padding: 50px;
  margin-bottom: 50px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  text-align: center;
  animation: slideUp 0.8s ease-out;
}

.aboutus-description h2 {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 20px;
}

.aboutus-desc {
  font-size: 16px;
  color: #555;
  line-height: 1.8;
  margin-bottom: 20px;
}

.aboutus-tagline {
  font-size: 16px;
  color: #007bff;
  font-weight: 500;
  line-height: 1.6;
}

/* Features Section */
.aboutus-features {
  background: white;
  border-radius: 15px;
  padding: 50px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  animation: slideUp 1s ease-out;
}

.aboutus-features h2 {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 40px;
  text-align: center;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 30px;
}

.feature-item {
  text-align: center;
  padding: 30px 20px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(0, 123, 255, 0.05) 0%, rgba(0, 123, 255, 0.02) 100%);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.feature-item:hover {
  transform: translateY(-5px);
  border-color: #007bff;
  background: linear-gradient(135deg, rgba(0, 123, 255, 0.1) 0%, rgba(0, 123, 255, 0.05) 100%);
}

.feature-number {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
  margin: 0 auto 15px;
  transition: transform 0.3s ease;
}

.feature-item:hover .feature-number {
  transform: scale(1.1);
}

.feature-item h4 {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 10px;
}

.feature-item p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* Responsive Design */
@media (max-width: 768px) {
  .aboutus-hero {
    height: 250px;
  }

  .aboutus-main {
    margin-top: -60px;
    padding: 0 15px;
  }

  .aboutus-header {
    flex-direction: column;
    text-align: center;
    gap: 20px;
    padding: 30px 20px;
    margin-bottom: 30px;
  }

  .aboutus-logo {
    width: 100px;
    height: 100px;
  }

  .aboutus-name {
    font-size: 24px;
  }

  .aboutus-description {
    padding: 30px 20px;
    margin-bottom: 30px;
  }

  .aboutus-description h2 {
    font-size: 22px;
  }

  .aboutus-desc {
    font-size: 14px;
  }

  .aboutus-features {
    padding: 30px 20px;
  }

  .aboutus-features h2 {
    font-size: 22px;
    margin-bottom: 30px;
  }

  .features-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
  }

  .info-card {
    padding: 20px 15px;
  }
}

@media (max-width: 480px) {
  .aboutus-hero {
    height: 200px;
  }

  .aboutus-header {
    padding: 20px 15px;
  }

  .aboutus-logo {
    width: 80px;
    height: 80px;
  }

  .aboutus-name {
    font-size: 20px;
  }

  .aboutus-en-name {
    font-size: 14px;
  }

  .aboutus-info-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .aboutus-description {
    padding: 20px 15px;
  }

  .aboutus-desc,
  .aboutus-tagline {
    font-size: 13px;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .feature-item {
    padding: 20px 15px;
  }
}

/* Dark Mode Support */
body.dark-mode .aboutus-container {
  background: linear-gradient(135deg, #121622 0%, #0d1425 100%);
}

body.dark-mode .aboutus-loading {
  color: #e0e0e0;
}

body.dark-mode .loader {
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top: 4px solid #4a9eff;
}

body.dark-mode .aboutus-banner-overlay {
  background: rgba(0, 0, 0, 0.5);
}

body.dark-mode .aboutus-header {
  background: #2d3644;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
}

body.dark-mode .aboutus-logo {
  border: 4px solid #3d3d54;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.5);
}

body.dark-mode .aboutus-name {
  color: #e0e0e0;
}

body.dark-mode .aboutus-en-name {
  color: #a0a0a0;
}

body.dark-mode .info-card {
  background: #2d3644;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  border-top: 4px solid #4a9eff;
}

body.dark-mode .info-card:hover {
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.5);
}

body.dark-mode .info-card h3 {
  color: #e0e0e0;
}

body.dark-mode .info-card p {
  color: #b0b0b0;
}

body.dark-mode .aboutus-description {
  background: #2d3644;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

body.dark-mode .aboutus-description h2 {
  color: #e0e0e0;
}

body.dark-mode .aboutus-desc {
  color: #b0b0b0;
}

body.dark-mode .aboutus-tagline {
  color: #4a9eff;
}

body.dark-mode .aboutus-features {
  background: #2d3644;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

body.dark-mode .aboutus-features h2 {
  color: #e0e0e0;
}

body.dark-mode .feature-item {
  background: linear-gradient(135deg, rgba(74, 158, 255, 0.1) 0%, rgba(74, 158, 255, 0.05) 100%);
  border: 2px solid transparent;
}

body.dark-mode .feature-item:hover {
  border-color: #4a9eff;
  background: linear-gradient(135deg, rgba(74, 158, 255, 0.15) 0%, rgba(74, 158, 255, 0.08) 100%);
}

body.dark-mode .feature-number {
  background: linear-gradient(135deg, #4a9eff 0%, #2a7acc 100%);
  color: white;
}

body.dark-mode .feature-item h4 {
  color: #e0e0e0;
}

body.dark-mode .feature-item p {
  color: #b0b0b0;
}


`, "",{"version":3,"sources":["webpack://./src/styles/aboutus.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,6FAA6F;EAC7F,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,4FAA4F;AAC9F;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;AAC/D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8FAA8F;EAC9F,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,+FAA+F;AACjG;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.aboutus-container {\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  min-height: 100vh;\n  padding-top: 60px;\n}\n\n/* Loading State */\n.aboutus-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  font-size: 18px;\n  gap: 15px;\n  color: #333;\n}\n\n.loader {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top: 4px solid #007bff;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Hero Banner Section */\n.aboutus-hero {\n  position: relative;\n  height: 400px;\n  overflow: hidden;\n}\n\n.aboutus-banner {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.aboutus-banner-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 1;\n}\n\n/* Main Content Section */\n.aboutus-main {\n  max-width: 1200px;\n  margin: -80px auto 0;\n  padding: 0 20px;\n  position: relative;\n  z-index: 2;\n}\n\n/* Header Section */\n.aboutus-header {\n  display: flex;\n  align-items: center;\n  gap: 40px;\n  background: white;\n  border-radius: 15px;\n  padding: 40px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  margin-bottom: 40px;\n  animation: slideUp 0.6s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.aboutus-logo-wrapper {\n  flex-shrink: 0;\n}\n\n.aboutus-logo {\n  width: 120px;\n  height: 120px;\n  border-radius: 15px;\n  object-fit: cover;\n  border: 4px solid #f0f0f0;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n  transition: transform 0.3s ease;\n}\n\n.aboutus-logo:hover {\n  transform: scale(1.05);\n}\n\n.aboutus-title-section {\n  flex-grow: 1;\n}\n\n.aboutus-name {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n  line-height: 1.2;\n}\n\n.aboutus-en-name {\n  font-size: 16px;\n  color: #666;\n  font-weight: 500;\n}\n\n/* Info Cards Grid */\n.aboutus-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 50px;\n}\n\n.info-card {\n  background: white;\n  border-radius: 12px;\n  padding: 30px 20px;\n  text-align: center;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n  border-top: 4px solid #007bff;\n}\n\n.info-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);\n}\n\n.card-icon {\n  font-size: 40px;\n  margin-bottom: 12px;\n}\n\n.info-card h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin-bottom: 10px;\n}\n\n.info-card p {\n  font-size: 14px;\n  color: #666;\n  line-height: 1.6;\n}\n\n/* Description Section */\n.aboutus-description {\n  background: white;\n  border-radius: 15px;\n  padding: 50px;\n  margin-bottom: 50px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);\n  text-align: center;\n  animation: slideUp 0.8s ease-out;\n}\n\n.aboutus-description h2 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 20px;\n}\n\n.aboutus-desc {\n  font-size: 16px;\n  color: #555;\n  line-height: 1.8;\n  margin-bottom: 20px;\n}\n\n.aboutus-tagline {\n  font-size: 16px;\n  color: #007bff;\n  font-weight: 500;\n  line-height: 1.6;\n}\n\n/* Features Section */\n.aboutus-features {\n  background: white;\n  border-radius: 15px;\n  padding: 50px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);\n  animation: slideUp 1s ease-out;\n}\n\n.aboutus-features h2 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 30px;\n}\n\n.feature-item {\n  text-align: center;\n  padding: 30px 20px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, rgba(0, 123, 255, 0.05) 0%, rgba(0, 123, 255, 0.02) 100%);\n  transition: all 0.3s ease;\n  border: 2px solid transparent;\n}\n\n.feature-item:hover {\n  transform: translateY(-5px);\n  border-color: #007bff;\n  background: linear-gradient(135deg, rgba(0, 123, 255, 0.1) 0%, rgba(0, 123, 255, 0.05) 100%);\n}\n\n.feature-number {\n  width: 50px;\n  height: 50px;\n  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  font-weight: bold;\n  margin: 0 auto 15px;\n  transition: transform 0.3s ease;\n}\n\n.feature-item:hover .feature-number {\n  transform: scale(1.1);\n}\n\n.feature-item h4 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin-bottom: 10px;\n}\n\n.feature-item p {\n  font-size: 14px;\n  color: #666;\n  line-height: 1.6;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .aboutus-hero {\n    height: 250px;\n  }\n\n  .aboutus-main {\n    margin-top: -60px;\n    padding: 0 15px;\n  }\n\n  .aboutus-header {\n    flex-direction: column;\n    text-align: center;\n    gap: 20px;\n    padding: 30px 20px;\n    margin-bottom: 30px;\n  }\n\n  .aboutus-logo {\n    width: 100px;\n    height: 100px;\n  }\n\n  .aboutus-name {\n    font-size: 24px;\n  }\n\n  .aboutus-description {\n    padding: 30px 20px;\n    margin-bottom: 30px;\n  }\n\n  .aboutus-description h2 {\n    font-size: 22px;\n  }\n\n  .aboutus-desc {\n    font-size: 14px;\n  }\n\n  .aboutus-features {\n    padding: 30px 20px;\n  }\n\n  .aboutus-features h2 {\n    font-size: 22px;\n    margin-bottom: 30px;\n  }\n\n  .features-grid {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 20px;\n  }\n\n  .info-card {\n    padding: 20px 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .aboutus-hero {\n    height: 200px;\n  }\n\n  .aboutus-header {\n    padding: 20px 15px;\n  }\n\n  .aboutus-logo {\n    width: 80px;\n    height: 80px;\n  }\n\n  .aboutus-name {\n    font-size: 20px;\n  }\n\n  .aboutus-en-name {\n    font-size: 14px;\n  }\n\n  .aboutus-info-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .aboutus-description {\n    padding: 20px 15px;\n  }\n\n  .aboutus-desc,\n  .aboutus-tagline {\n    font-size: 13px;\n  }\n\n  .features-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .feature-item {\n    padding: 20px 15px;\n  }\n}\n\n/* Dark Mode Support */\nbody.dark-mode .aboutus-container {\n  background: linear-gradient(135deg, #121622 0%, #0d1425 100%);\n}\n\nbody.dark-mode .aboutus-loading {\n  color: #e0e0e0;\n}\n\nbody.dark-mode .loader {\n  border: 4px solid rgba(255, 255, 255, 0.1);\n  border-top: 4px solid #4a9eff;\n}\n\nbody.dark-mode .aboutus-banner-overlay {\n  background: rgba(0, 0, 0, 0.5);\n}\n\nbody.dark-mode .aboutus-header {\n  background: #2d3644;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);\n}\n\nbody.dark-mode .aboutus-logo {\n  border: 4px solid #3d3d54;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.5);\n}\n\nbody.dark-mode .aboutus-name {\n  color: #e0e0e0;\n}\n\nbody.dark-mode .aboutus-en-name {\n  color: #a0a0a0;\n}\n\nbody.dark-mode .info-card {\n  background: #2d3644;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);\n  border-top: 4px solid #4a9eff;\n}\n\nbody.dark-mode .info-card:hover {\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.5);\n}\n\nbody.dark-mode .info-card h3 {\n  color: #e0e0e0;\n}\n\nbody.dark-mode .info-card p {\n  color: #b0b0b0;\n}\n\nbody.dark-mode .aboutus-description {\n  background: #2d3644;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\nbody.dark-mode .aboutus-description h2 {\n  color: #e0e0e0;\n}\n\nbody.dark-mode .aboutus-desc {\n  color: #b0b0b0;\n}\n\nbody.dark-mode .aboutus-tagline {\n  color: #4a9eff;\n}\n\nbody.dark-mode .aboutus-features {\n  background: #2d3644;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\nbody.dark-mode .aboutus-features h2 {\n  color: #e0e0e0;\n}\n\nbody.dark-mode .feature-item {\n  background: linear-gradient(135deg, rgba(74, 158, 255, 0.1) 0%, rgba(74, 158, 255, 0.05) 100%);\n  border: 2px solid transparent;\n}\n\nbody.dark-mode .feature-item:hover {\n  border-color: #4a9eff;\n  background: linear-gradient(135deg, rgba(74, 158, 255, 0.15) 0%, rgba(74, 158, 255, 0.08) 100%);\n}\n\nbody.dark-mode .feature-number {\n  background: linear-gradient(135deg, #4a9eff 0%, #2a7acc 100%);\n  color: white;\n}\n\nbody.dark-mode .feature-item h4 {\n  color: #e0e0e0;\n}\n\nbody.dark-mode .feature-item p {\n  color: #b0b0b0;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
